import { client } from "api";
import { Company } from "models/Company";

export type BlockCompanyRequest = {
  companyId: string;
  reason?: string;
};

export type BlockCompanyResponse = Company;

export const blockCompany = ({ companyId, reason }: BlockCompanyRequest) =>
  client.post<BlockCompanyResponse>(`/company/${companyId}/block`, { reason }).then((res) => res.data);
